const generateBreadcrumbs = data => {
    const urlBase = '/teachers-cabinet'
    const base = [
        {name: 'Курсы', link: urlBase},
        {name: data.course_title, link: `${urlBase}/course/${data.course_id}`}
    ]
    if (data.paragraph_id) {
        base.push({name: data.paragraph_title, link: `${urlBase}/course/${data.paragraph_id}`})
    }
    if (data.theme_id) {
        base.push({name: data.theme_title, link: `${urlBase}/course/${data.theme_id}`})
    }
    return base
}

export default generateBreadcrumbs